import Flatpickr from "stimulus-flatpickr";
import "flatpickr/dist/themes/light.css";

import { Latvian } from 'flatpickr/dist/l10n/lv.js'
flatpickr.localize(Latvian);

export default class extends Flatpickr {}
